<template>
  <v-container>
    <v-row >
      <v-col>
        <p class="text-h3">Welcome to gw2data.app. </p>
        <p class="text-body-1">
          This app uses the official GW2 API to "snapshot" 
          the state of your account and compare it to the live state at some 
          point in the future.
        </p>
        <p>
          The differences observed between these two states
          can be saved in this app, and/or downloaded as CSV.
        </p>
        <p>
          Records saved to the app can be tagged, and searched for later 
          reference, CSV download and reporting(soon).
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>